const openBarGame = (args = {}) => window.HiyaJSBridge.callHandler("openBarGame", { ...args, target: args.target >= 0 ? args.target : 0 });
export {
  openBarGame
};
